import { PaymentMethodType } from "@KassaroAB/shared/types/enums/PaymentMethodType";
import type { RestCreatePaymentMethod } from "@KassaroAB/shared/types/paymentMethods/paymentMethod";
import type { PaymentMethodFormProps } from "./PaymentMethodFormContainer";
import { PaymentMethodBaseForm } from "./PaymentMethodBaseForm";
import { CashForm } from "./CashForm";
import { CreditNoteForm } from "./CreditNoteForm";
import { GiftCardForm } from "./GiftCardForm";
import { OtherForm } from "./OtherForm";
import { SwishCompanyForm } from "./SwishCompanyForm";
import { SwishCommerceForm } from "./SwishCommerceForm";
import { WestpayCloudForm } from "./WestpayCloudForm";
import { MarketPayCloudForm } from "./MarketPayCloudForm";
import { MarketpayLocalForm } from "./MarketpayLocalForm";
import { MarketpaySdkForm } from "./MarketpaySdkForm";
import { NetsTerminalForm } from "./NetsTerminalForm";
import { SoftpayForm } from "./SoftpayForm";
import { VivaForm } from "./VivaForm";
import { VivaCloudForm } from "./VivaCloudForm";
import { InvoiceForm } from "./InvoiceForm";
import { OrderForm } from "./OrderForm";
import { PaymentLinkForm } from "./PaymentLinkForm";

export const PaymentMethodForm = ({
  paymentMethod,
  ...props
}: PaymentMethodFormProps<RestCreatePaymentMethod>) => {
  if (paymentMethod.type === PaymentMethodType.SWISH_COMPANY) {
    return <SwishCompanyForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.SWISH_COMMERCE) {
    return <SwishCommerceForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.WESTPAY_CLOUD) {
    return <WestpayCloudForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.MARKETPAY_CLOUD) {
    return <MarketPayCloudForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.MARKETPAY_LOCAL) {
    return <MarketpayLocalForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.NETS_TERMINAL) {
    return <NetsTerminalForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.VIVA_CLOUD) {
    return <VivaCloudForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.VIVA) {
    return <VivaForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.SOFTPAY) {
    return <SoftpayForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.INVOICE) {
    return <InvoiceForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.ORDER) {
    return <OrderForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.CASH) {
    return <CashForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.CREDIT_NOTE) {
    return <CreditNoteForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.GIFT_CARD) {
    return <GiftCardForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.OTHER) {
    return <OtherForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.MARKETPAY_SDK) {
    return <MarketpaySdkForm paymentMethod={paymentMethod} {...props} />;
  }
  if (paymentMethod.type === PaymentMethodType.PAYMENT_LINK) {
    return <PaymentLinkForm paymentMethod={paymentMethod} {...props} />;
  }
  return <PaymentMethodBaseForm paymentMethod={paymentMethod} {...props} />;
};
